import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SignUpMainFormStepMobile from './Steps/MainForm/SignUpMainFormStepMobile';
import SignUpConfirmStepMobile from './Steps/Confirm/SignUpConfirmStepMobile';
import SignUpGreatWorkStepMobile from './Steps/GreatWork/SignUpGreatWorkStepMobile';

function SignUpPageMobile() {
  return (
    <Routes>
      <Route path={'/'} element={<SignUpMainFormStepMobile />} />
      <Route path={'/confirm'} element={<SignUpConfirmStepMobile />} />
      <Route path={'/success'} element={<SignUpGreatWorkStepMobile />} />
    </Routes>
  );
}

export default SignUpPageMobile;
